import React from 'react';
import { NewoDropMultiFileListItem } from "./drop-multi-file-no-typology-list-item";
import { useTranslation } from 'react-i18next';
import { nsnewo } from "../../../i18n/namespaces";
export const NewoDropMultiFileList = props => {
  const {
    common,
    arhiveIdStateRecord,
    archiveIdDocumentalResultRecord,
    status
  } = props;
  const {
    value
  } = common;
  const {
    remove
  } = status;
  const {
    t
  } = useTranslation(nsnewo.common);
  return /*#__PURE__*/React.createElement(React.Fragment, null, value && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row text-xl-start align-items-center justify-content-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-9 pb-xl-2"
  }, value.accepted.map(accepted => /*#__PURE__*/React.createElement(React.Fragment, {
    key: accepted.id
  }, /*#__PURE__*/React.createElement(NewoDropMultiFileListItem, {
    value: accepted,
    archiveInputState: arhiveIdStateRecord[accepted.id],
    remove: () => remove(accepted.id),
    documentalTypologyResult: archiveIdDocumentalResultRecord[accepted.id]
  }), /*#__PURE__*/React.createElement("hr", {
    className: "d-xl-none border-secondary border-3 rounded-pill mb-4"
  })))), !common.disabled && /*#__PURE__*/React.createElement("div", {
    className: "col-xl-3 text-center filebox"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-5 pe-4 text-end"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mdi mdi-cloud-upload mdi-48px text-secondary"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-7 text-start"
  }, /*#__PURE__*/React.createElement("span", null, t('newo.documentalValidation.dropText1'), /*#__PURE__*/React.createElement("br", null), t('newo.documentalValidation.dropText2')))))))));
};